import { IconButton } from "@mui/material";
import React from "react";
import { Draggable } from "react-beautiful-dnd";

import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { useSelector } from "react-redux";

export default function TaskTimeslot({ task, index, setComplete }) {
  const event = useSelector((state) =>
    state.tasks.find((c) => c.id === task.taskId)
  );
  const courseColor = useSelector((state) =>
    state.courses.find((c) => c.id === event?.courseId)
  )?.color;
  const getBorderColor = () => {
    if (!event) {
      return "beige";
    }
    switch (event.type) {
      case "EVENT":
        return "#457b3b";
      case "ASSIGNMENT":
        return "#3873cb";
      case "EXAM":
        return "red";
      case "QUIZ":
        return "#9031aa";
    }
  };

  return (
    <Draggable key={task.id} draggableId={task.id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          //   style={{ padding: "3px" }}
        >
          <div
            style={{
              backgroundColor: courseColor
                ? courseColor
                : event
                ? "#eee"
                : "beige",
              borderRadius: "5px",
              margin: "2px",
              borderRight: "26px solid",
              borderRightColor: getBorderColor(),
              textAlign: "center",
              color: "black",
              display: "flex",
              position: "relative",
            }}
          >
            <div
              style={{
                paddingTop: "5px",
                paddingBottom: "5px",
                paddingLeft: "4px",
                flexGrow: 1,
              }}
            >
              {task.name}
            </div>
            <div
              style={{
                position: "absolute",
                right: -25,
                top: 3,
                width: "24px",
                minHeight: "20px",
                height: "100%",
                cursor: "pointer",
              }}
              onClick={() => setComplete(task)}
            >
              <CheckCircleOutlineOutlinedIcon style={{ fill: "black" }} />
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
}
